export const MERCHANT_AUTH_URL = `/merchant/auth`
export const MERCHANT_SIMBART_BASEINFOS_URL = `/merchant/simbart`

/**
 * 登录验证码
 */
export const LOGIN_CAPTCHA_IMAGE_URL = `${MERCHANT_AUTH_URL}/captcha.jpg`
/**
 * 滑块验证码接口
 */
export const SLIDER_CAPTCHA_URL = `${MERCHANT_AUTH_URL}/captcha/slider`
/**
 * 校验滑块验证码接口
 */
export const SLIDER_CAPTCHA_CHECK_URL = `${MERCHANT_AUTH_URL}/captcha/slider/check`
/**
 * 登录地址
 */
export const LOGIN_URL = `${MERCHANT_AUTH_URL}/main/login`
/**
 * 重置密码接口
 */
export const RESET_PASSWORD_URL = `${MERCHANT_AUTH_URL}/main/reset-password`
/**
 * 获取商户列表接口（LOGIN_TEMP场景）
 */
export const GET_MERCHANTS_URL = `${MERCHANT_AUTH_URL}/main/merchants`
/**
 * 选择商户并获取正式token接口（LOGIN_TEMP场景）
 */
export const SELECT_MERCHANT_URL = `${MERCHANT_AUTH_URL}/main/select-merchant`

/**
 * 获取商户基本信息
 */
export const GET_MERCHANT_BASE_INFOS_URL = `${MERCHANT_AUTH_URL}/baseinfos`

/**
 * 通过手机号查询商户
 */
export const GET_MERCHANT_BASE_INFOS_BY_MOBILE_URL = `${MERCHANT_SIMBART_BASEINFOS_URL}/baseInfosByMobile`

/**
 * 获取指定商户基本信息
 */
export const GET_MERCHANT_BASE_INFO_URL = `${MERCHANT_AUTH_URL}/baseinfo`

/**
 * 商户平台 - 商户权限管理服务
 */
export const MERCHANT_SYSTEM_URL = `/merchant/system`

/**
 * 商户平台 - 当前管理员
 */
export const SYSTEM_MERCHANT_ME_URL = `${MERCHANT_SYSTEM_URL}/me`

/**
 * 商户平台 - 角色管理
 */
export const SYSTEM_MERCHANT_ROLE_URL = `${MERCHANT_SYSTEM_URL}/role`

/**
 * 商户平台 - 管理员管理
 */
export const SYSTEM_MERCHANT_ADMIN_URL = `${MERCHANT_SYSTEM_URL}/admin`

/**
 * 商户平台 - 开放账号
 */
export const SYSTEM_MERCHANT_OPEN_ACCOUNT_URL = `${MERCHANT_SYSTEM_URL}/open_account`

/**
 * 商户平台 - 赛事管理
 */
export const MERCHANT_SIMBART_URL = `/merchant/simbart`

/**
 * 商户平台 - 赛事管理 - 分类配置
 */
export const SIMBART_MERCHANT_ACTIVITY_CONFIG_CATEGORY_URL = `${MERCHANT_SIMBART_URL}/config_category`

/**
 * 商户平台 - 赛事管理 - 组别配置
 */
export const SIMBART_MERCHANT_ACTIVITY_CONFIG_GROUP_URL = `${MERCHANT_SIMBART_URL}/config_group`

/**
 * 商户平台 - 赛事管理 - 报名配置
 */
export const SIMBART_MERCHANT_ACTIVITY_CONFIG_ENTRY_FORM_URL = `${MERCHANT_SIMBART_URL}/config_entry_form`

/**
 * 商户平台 - 赛事管理 - 人气礼物配置
 */
export const SIMBART_MERCHANT_ACTIVITY_CONFIG_GIFT_URL = `${MERCHANT_SIMBART_URL}/config_gift`

/**
 * 商户平台 - 赛事管理 - 活动管理
 */
export const SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL = `${MERCHANT_SIMBART_URL}/competition`

/**
 * 商户平台 - 赛事管理 - 榜单管理
 */
export const SIMBART_MERCHANT_RANKING_BOARD_URL = `${MERCHANT_SIMBART_URL}/rankingBoard`

/**
 * 商户平台 - 赛事管理 - 展示墙
 */
export const SIMBART_MERCHANT_DISPLAY_WALL_URL = `${MERCHANT_SIMBART_URL}/displayWall`

/**
 * 商户平台 - 赛事管理 - 参与活动
 */
export const SIMBART_MERCHANT_ACTIVITY_JOIN_COMPETITION_URL = `${MERCHANT_SIMBART_URL}/join_competition`

/**
 * 商户平台 - 赛事管理 - 定价券
 */
export const SIMBART_MERCHANT_ACTIVITY_PROMOTION_CODE_URL = `${MERCHANT_SIMBART_URL}/promotion_code`

/**
 * 商户平台 - 赛事管理 - 广告配置
 */
export const SIMBART_MERCHANT_ACTIVITY_COMPETITION_AD_URL = `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/ad`

/**
 * 商户平台 - 赛事管理 - 广告配置
 */
export const SIMBART_MERCHANT_ACTIVITY_COMPETITION_AWARD_URL = `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_URL}/award`

/**
 * 商户平台 - 广告管理 - 广告配置
 */
export const SIMBART_MERCHANT_AD_CONFIG_URL = `${MERCHANT_SIMBART_URL}/ad/config`

/**
 * 上传图片及视频url
 */
export const MERCHANT_OSS_URI = '/merchant/oss'

/**
 * 上传公共图片签名URL
 */
export const MERCHANT_OSS_UPLOAD_PUBLIC_SIGNED_URI = `${MERCHANT_OSS_URI}/public`

/**
 * 公共数据 HOST
 */
export const MERCHANT_OSS_UPLOAD_PUBLIC_HOST = `${MERCHANT_OSS_URI}/public/host`

/**
 * 获取预览签名二维码
 */
export const MERCHANT_OSS_GET_PRESIGNEDURL_URI = `${MERCHANT_OSS_URI}/public/presignedurl`

/**
 * 获取下载url
 */
export const MERCHANT_OSS_GET_PUBLIC_DOWNLOAD_URI = `${MERCHANT_OSS_URI}/public/downloadurl`

/**
 * 上传私有图片签名URL
 */
export const MERCHANT_OSS_UPLOAD_PRIVATE_SIGNED_URI = `${MERCHANT_OSS_URI}/private`

/**
 * 获取私有图片签名url
 */
export const MERCHANT_OSS_GET_PRIVATE_SIGNED_URI = `${MERCHANT_OSS_URI}/private/get`

/**
 * 商户平台 - 财务中心
 */
export const MERCHANT_FINANCE_URI = `/merchant/finance`

/**
 * 交易管理
 */
export const MERCHANT_FINANCE_TRANSACTION_URL = `${MERCHANT_FINANCE_URI}/transaction`

/**
 * 流水管理
 */
export const MERCHANT_FINANCE_ACCOUNT_STATEMENT_URL = `${MERCHANT_FINANCE_URI}/account_statement`

/**
 * 流水汇总
 */
export const MERCHANT_FINANCE_ACCOUNT_STATEMENT_SUMMARY_URL = `${MERCHANT_FINANCE_URI}/account_statement_summary`

/**
 * 商户平台 - 教务中心
 */
export const MERCHANT_EDUCATION_URI = `/merchant/education`

/**
 * 直播教室管理
 */
export const MERCHANT_EDUCATION_LIVE_CLASSROOM_URL = `${MERCHANT_EDUCATION_URI}/live_classroom`

/**
 * 商户平台 - 评审中心
 */
export const MERCHANT_EVALUATION_URI = `/merchant/evaluation`

/**
 * 评审方案管理
 */
export const MERCHANT_EVALUATION_SCHEME_CONFIG_URI = `${MERCHANT_EVALUATION_URI}/scheme_config`

/**
 * 评委管理
 */
export const MERCHANT_EVALUATION_JUDGE_URI = `${MERCHANT_EVALUATION_URI}/judge`

/**
 * 批量添加评委
 */
export const MERCHANT_EVALUATION_JUDGE_BATCH_ADD = `${MERCHANT_EVALUATION_URI}/judge/batchAdd`
/**
 * 评审项目管理
 */
export const MERCHANT_EVALUATION_PROJECT_URI = `${MERCHANT_EVALUATION_URI}/project`

/**
 * 项目排名管理
 */
export const MERCHANT_EVALUATION_PROJECT_RANK_URI = `${MERCHANT_EVALUATION_URI}/project_rank`

/**
 * 奖项模板管理
 */
export const MERCHANT_EVALUATION_RANK_TEMPLATE_URI = `${MERCHANT_EVALUATION_URI}/rank_template`

/**
 * 电子奖状 - 证书模板管理
 */
export const MERCHANT_CERTIFICATE_TEMPLATE_URI = `${MERCHANT_SIMBART_URL}/certificate/template`

/**
 * 电子奖状 - 证书生成记录
 */
export const MERCHANT_CERTIFICATE_GENERATION_URI = `${MERCHANT_SIMBART_URL}/certificate/generation`

/**
 * 商户平台 - Coze 智能体
 */
export const MERCHANT_COZE_URI = `${MERCHANT_SIMBART_URL}/coze`

/**
 * 参评记录 PDF / 收件单导出任务（商户维度列表）
 */
export const MERCHANT_EVALUATION_EXPORT_ENTRY_PDF_TASKS_URI = `${MERCHANT_EVALUATION_URI}/export-entry-pdf/tasks`

/**
 * 商户平台 - 短信中心
 */
export const MERCHANT_SMS_URI = `/merchant/sms`

/**
 * 签名管理
 */
export const MERCHANT_SMS_SIGN_URI = `${MERCHANT_SMS_URI}/sign`

/**
 * 短信模版管理
 */
export const MERCHANT_SMS_TEMPLATE_URI = `${MERCHANT_SMS_URI}/template`

/**
 * 通讯录管理
 */
export const MERCHANT_SMS_CONTACT_URI = `${MERCHANT_SMS_URI}/contact`

/**
 * 通讯录分组管理
 */
export const MERCHANT_SMS_CONTACT_GROUP_URI = `${MERCHANT_SMS_URI}/contact_group`

/**
 * 短信管理
 */
export const MERCHANT_SMS_MESSAGE_URI = `${MERCHANT_SMS_URI}/message`

/**
 * 短信包管理
 */
export const MERCHANT_SMS_PACKAGE_URI = `${MERCHANT_SMS_URI}/package`

/**
 * 短信包产品管理
 */
export const MERCHANT_SMS_GOODS_URI = `${MERCHANT_SMS_URI}/goods`

/**
 * 帮助中心
 */
export const MERCHANT_HELP_URI = `/merchant/help`

/**
 * 帮助配置
 */
export const MERCHANT_HELP_CONFIG_URI = `${MERCHANT_HELP_URI}/config`

/**
 * 考级中心
 */
export const MERCHANT_GRADE_URI = `/merchant/grade`

/**
 * 学员资料
 */
export const MERCHANT_GRADE_EXAMINEE_URI = `${MERCHANT_GRADE_URI}/examinee`

/**
 * 考级项目
 */
export const MERCHANT_GRADE_PROJECT_URI = `${MERCHANT_GRADE_URI}/project`

/**
 * 通用接口
 */
export const MERCHANT_COMMON_URI = `/merchant/common`

/**
 * 通用接口-哈希缓存
 */
export const MERCHANT_COMMON_CACHEDATA_URI = `${MERCHANT_COMMON_URI}/cacheData`

/**
 * 通用接口-报名小程序
 */
export const MERCHANT_COMMON_MINIAPP_URI = `${MERCHANT_COMMON_URI}/miniapp`

/**
 * 通用接口-商户端小程序
 */
export const MERCHANT_COMMON_MANAGER_MINIAPP_URI = `${MERCHANT_COMMON_URI}/manager-miniapp`

/**
 * 商户平台 - 商户权限管理服务
 */
export const MERCHANT_REPORT_URL = `/merchant/report`
/**
 * 商户平台 - 活动管理 - 数据大屏
 */
export const MERCHANT_REPORT_PROJECT_TEMPLATE_URL = `${MERCHANT_REPORT_URL}/project_template`

/**
 * 商户平台 - 活动管理 - 数据报表
 */
export const MERCHANT_REPORT_BI_URL = `${MERCHANT_REPORT_URL}/bi`

/**
 * 移动端公开接口 - 展示墙
 */
export const MOBILE_SIMBART_PUBLIC_URL = `/mobile/simbart/public`



// WEBPACK FOOTER //
// ./src/api/urls.js